import type { QuerySettings } from '@customTypes/index';
import type { SearchParams } from '@customTypes/types';
import { useQuery } from '@tanstack/react-query';

import { getClubsActivityList } from './request';

export const useGetClubsActivityListQuery = (
  params: SearchParams,
  settings?: QuerySettings<typeof getClubsActivityList>
) =>
  useQuery({
    queryKey: ['GetClubsActivityList', params.pageNumber],
    queryFn: () =>
      getClubsActivityList({
        config: {
          ...settings?.config,
          params: {
            pageNumber: params.pageNumber
          }
        }
      }),
    ...settings?.config
  });
